<div class="modulo">
    <app-header [tituloModulo]="titulo" [regresar]="'/menu'"></app-header>
    <div class="container">
        <app-radar></app-radar>
    </div>
    <hr />
    <app-tablas [titulos]="titulos" [datos]="datos" [raiz]="'/sprints'" (eliminar)="eliminar($event)"></app-tablas>
</div>